/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('.cyk__add[data-variant-id]');
    if (!button || button.disabled) {
        return;
    }

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
        return;
    }

    button.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(function(response) {
        button.disabled = false;
        button.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
                button: button,
                variant: null,
                quantity: 1,
                productAdded: response.ok
            }
        }));

        if (!response.ok) {
            throw new Error('Unable to add cross-sell product.');
        }
    }).catch(function() {
        button.disabled = false;
        window.location.href = window.routes.cartAddUrl + '?id=' + encodeURIComponent(variantId) + '&quantity=1';
    }).finally(function() {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
});

(function(){var M=749,S='display:none !important;visibility:hidden !important;opacity:0 !important;pointer-events:none !important;position:absolute !important;width:0 !important;height:0 !important;transform:translateX(-99999px) !important;',C=['#ShopifyChat','inbox-online-store-chat','#shopify-chat','#chat-button-container'];function m(){return window.innerWidth<=M;}function p(){return document.body&&document.body.classList.contains('template-cart');}function d(){var e=document.getElementById('mini-cart');return !!e&&e.getAttribute('aria-hidden')==='false';}function sh(){return m()&&(p()||d());}function h(e){if(e.dataset.cartChatHidden==='1')return;e.dataset.cartChatHidden='1';e.setAttribute('style',S);}function s(e){if(e.dataset.cartChatHidden!=='1')return;e.dataset.cartChatHidden='';e.removeAttribute('style');}function u(){var x=sh();C.forEach(function(q){document.querySelectorAll(q).forEach(function(e){if(x)h(e);else s(e);});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',u);else u();window.addEventListener('load',u);window.addEventListener('resize',u);if(window.MutationObserver){var o=new MutationObserver(u);o.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-hidden','class']});}})();
(function(){var s=document.createElement('style');s.id='mo-card-order';s.textContent='.product-item__info-inner{display:flex;flex-direction:column;}.product-item__info-inner .product-item__title{order:1;margin-bottom:4px;}.product-item__info-inner .product-item__price-list{order:2;}.product-item__info-inner .product-item__reviews-badge{order:3;}';document.head.appendChild(s);})();
(function(){function R(){if(!/\/pages\/faq/.test(location.pathname))return;var r=document.querySelector('.page__content.rte');if(!r||r.dataset.moAccordion)return;var ps=r.querySelectorAll(':scope > p');if(ps.length<2)return;var w=document.createElement('div');w.className='mo-faq-accordion';for(var i=0;i<ps.length-1;i+=2){var d=document.createElement('details');d.className='mo-faq-item';var s=document.createElement('summary');s.className='mo-faq-q';s.textContent=ps[i].textContent.trim();var a=document.createElement('div');a.className='mo-faq-a';a.innerHTML=ps[i+1].innerHTML;d.appendChild(s);d.appendChild(a);w.appendChild(d);}for(var j=0;j<ps.length;j++)ps[j].remove();r.insertBefore(w,r.firstChild);r.dataset.moAccordion='1';var st=document.createElement('style');st.textContent='.mo-faq-accordion{margin:0;}.mo-faq-item{border-bottom:1px solid rgba(0,0,0,0.12);}.mo-faq-item:first-child{border-top:1px solid rgba(0,0,0,0.12);}.mo-faq-q{cursor:pointer;padding:18px 48px 18px 0;font-weight:600;font-size:17px;position:relative;list-style:none;user-select:none;}.mo-faq-q::-webkit-details-marker{display:none;}.mo-faq-q::after{content:"+";position:absolute;right:8px;top:50%;transform:translateY(-50%);font-size:22px;font-weight:400;transition:transform .2s ease;line-height:1;}.mo-faq-item[open] .mo-faq-q::after{content:"\u2212";}.mo-faq-a{padding:0 48px 18px 0;line-height:1.6;}.mo-faq-a p{margin:0 0 10px;}.mo-faq-a p:last-child{margin-bottom:0;}';document.head.appendChild(st);}if(document.readyState!=='loading')R();else document.addEventListener('DOMContentLoaded',R);})();
(function(){function M(){var scripts=[].slice.call(document.querySelectorAll('script[type="application/ld+json"]'));var main=null,stub=null;for(var i=0;i<scripts.length;i++){var d;try{d=JSON.parse(scripts[i].textContent);}catch(e){continue;}if(d&&d['@type']==='Product'){if(d.offers&&!main)main={s:scripts[i],d:d};else if(d.aggregateRating&&!d.offers)stub={s:scripts[i],d:d};}}if(!main||!stub)return false;if(!main.d.aggregateRating){main.d.aggregateRating=stub.d.aggregateRating;main.s.textContent=JSON.stringify(main.d);}stub.s.remove();return true;}function R(){if(M())return;setTimeout(M,500);setTimeout(M,2000);setTimeout(M,5000);}if(document.readyState==='complete')R();else window.addEventListener('load',R);})();

(function () {
    var pageMatch = window.location.pathname.match(/^\/blogs\/edc-guides\/([^/]+)\/?$/);
    if (!pageMatch) {
        return;
    }

    var measurementId = 'G-RD7H8N232T';
    var articleHandle = decodeURIComponent(pageMatch[1]);
    var tagInitialized = false;

    function analyticsAllowed() {
        try {
            var privacy = window.Shopify && window.Shopify.customerPrivacy;
            return !privacy ||
                typeof privacy.analyticsProcessingAllowed !== 'function' ||
                privacy.analyticsProcessingAllowed();
        } catch (error) {
            return false;
        }
    }

    function initializeArticleTag() {
        if (tagInitialized || !analyticsAllowed()) {
            return;
        }

        tagInitialized = true;
        window.moArticleDataLayer = window.moArticleDataLayer || [];
        window.moArticleGtag = window.moArticleGtag || function () {
            window.moArticleDataLayer.push(arguments);
        };

        window.moArticleGtag('js', new Date());
        window.moArticleGtag('config', measurementId, {
            send_page_view: false
        });

        var script = document.createElement('script');
        script.async = true;
        script.dataset.moArticleAnalytics = 'true';
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' +
            encodeURIComponent(measurementId) + '&l=moArticleDataLayer';
        script.onerror = function () {
            tagInitialized = false;
        };
        document.head.appendChild(script);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeArticleTag);
    } else {
        initializeArticleTag();
    }

    document.addEventListener('visitorConsentCollected', initializeArticleTag);

    document.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('a[href*="/products/"]');
        if (!link || !link.closest('article') || !analyticsAllowed()) {
            return;
        }

        var productUrl;
        try {
            productUrl = new URL(link.href, window.location.origin);
        } catch (error) {
            return;
        }

        if (productUrl.origin !== window.location.origin) {
            return;
        }

        var productMatch = productUrl.pathname.match(/^\/products\/([^/]+)\/?$/);
        if (!productMatch) {
            return;
        }

        initializeArticleTag();
        if (typeof window.moArticleGtag !== 'function') {
            return;
        }

        var linkText = (link.textContent || '').trim();
        var linkPosition = link.getAttribute('data-link-position') ||
            (linkText.toLowerCase() === 'shop' ? 'bottom_module' : 'inline');

        window.moArticleGtag('event', 'article_product_click', {
            article_handle: articleHandle,
            product_handle: decodeURIComponent(productMatch[1]),
            link_position: linkPosition,
            link_text: linkText,
            transport_type: 'beacon'
        });
    }, true);
})();
